import { Container } from "@material-ui/core";
import { Typography } from "@mui/material";
import React from "react";
import "./Blog.css";

const Blog = () => {
  return (
    <>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <Container>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div>
            <Typography variant="h4" style={{ color: "#ff0266" }}>
              {" "}
              Blog
            </Typography>
            <div
              style={{
                borderBottom: "2px solid #fff",
                display: "flex",
                justifyContent: "center",
              }}
            ></div>
          </div>
        </div>
        <div className="blog-container">
          <div className="left">
            <img
              width="100%"
              height="100%"
              src="https://i.ibb.co/N1TRfc0/1-ffn-8-KUw-Jzhc-Du-QP5a4oow.jpg"
              alt=""
            />
          </div>
          <div className="right_container">
            <div className="content">
              <h1>Array in javascript</h1>
              <p>
                Array is a data structure that contains a group of elements. JS
                arrays can contain...
              </p>
              <a
                href="https://morshed247.medium.com/array-ee1dd2d53532"
                target="_blank"
                rel="noreferrer"
                className="btn"
              >
                Learn More <span>&rarr;</span>
              </a>
            </div>
          </div>
        </div>
        <div className="blog-container">
          <div className="left">
            <img
              width="100%"
              height="100%"
              src="https://i.ibb.co/pfC3F9S/1-C4u-EKBan-ML9-Q8q5-4-HV3-Q.jpg"
              alt=""
            />
          </div>
          <div className="right_container">
            <div className="content">
              <h1>Data type</h1>
              <p>
                Spread operator (…)is a smart addition in JavaScript of ES6.
                Spread operator can be used..
              </p>
              <a
                href="https://morshed247.medium.com/basic-javascript-a595855f4f0d"
                target="_blank"
                rel="noreferrer"
                className="btn"
              >
                Learn More <span>&rarr;</span>
              </a>
            </div>
          </div>
        </div>
        <div className="blog-container">
          <div className="left">
            <img
              width="100%"
              height="100%"
              objectFit="cover"
              overflow="hidden"
              src="https://i.ibb.co/98K1N4m/cover-a1d5b40.png"
              alt=""
            />
          </div>
          <div className="right_container">
            <div className="content">
              <h1>Basic React</h1>
              <p>
                React is declarative, efficient, flexible for building user
                interfaces..
              </p>
              <a
                href="https://morshed247.medium.com/basic-react-b109ae50c37c"
                target="_blank"
                rel="noreferrer"
                className="btn"
              >
                Learn More <span>&rarr;</span>
              </a>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Blog;
